import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "34.025",
  width: "50",
  viewBox: "0 0 50 34.025",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M50 34.025H0V0h49.948v34.025zm-46.37-3.63h42.687V3.63H3.63v26.764z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M24.533 17.894l7.625 5.24L43.983 11.98V6.95l-12.19 11.515-7.467-5.135-12.034 10.166-6.172-3.683v4.253l6.484 3.89zm-8.506-5.446a3.942 3.942 0 0 1-3.942 3.942 3.942 3.942 0 0 1-3.942-3.942 3.942 3.942 0 0 1 3.942-3.942 3.942 3.942 0 0 1 3.942 3.942z"
  })]
});